import { Link } from "react-router-dom";
import { base_url } from "../../constants";
import Return_arrow from "./../../assets/images/svg/return_arrow.svg";
import {IconReturn} from "../../utilities/ReturnBack";

export default function Breadcrumb() {
    return(
        <div className="container-fluid px-0">
            <div className="row mx-3 mx-sm-0">
                <div className="col-12 mt-4 px-0 top_breadcrumb text-end">
                    <nav aria-label="breadcrumb" className="mb-0 col-12 px-5">
                        <ol className="col-12 breadcrumb contenedor_breadcrumb mb-0">
                            <li className="breadcrumb-item">
                            <Link to={`/${base_url}/${localStorage.getItem('seccion')}`}>{ localStorage.getItem('seccion') }</Link></li>
                            <div className="col d-flex justify-content-end">                           
                               <IconReturn/>                                                          
                            </div>
                        </ol>
                    </nav>
                </div>                
            </div>
        </div>
    )
}